import "@/App.css";
import { PART1, PART3 } from "@/data/landingHtml";
import JourneySection from "@/components/JourneySection";
import MobileNavDrawer from "@/components/MobileNavDrawer";
import StickyReserveBar from "@/components/StickyReserveBar";
import BookingInquiry from "@/components/BookingInquiry";

const App = () => {
  return (
    <div className="App bg-[#F4F1EA] min-h-screen text-[#2C3029]">
      <div dangerouslySetInnerHTML={{ __html: PART1 }} />
      <JourneySection />
      <div dangerouslySetInnerHTML={{ __html: PART3 }} />
      <MobileNavDrawer />
      <StickyReserveBar />
      <BookingInquiry />
    </div>
  );
};

export default App;
